module.exports = __webpack_public_path__ + "static/xz-69e0b37e3a4feed7079fb377fab906ca.png";